import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './HeroHeader.scss';
import api from '../../api';
import { useAuth } from 'react-oidc-context';
import { useAppUser } from '../../context/UserContext/UserContext';

const ANONYMOUS_ROOM_LIMIT = 9;
const ACCOUNT_ROOM_LIMIT = 12;

const HeroHeader = () => {
    const [roomCount, setRoomCount] = useState(0);
    const auth = useAuth();
    const { user: appUser, loading: appUserLoading } = useAppUser();
    const roomLimit = auth.isAuthenticated ? ACCOUNT_ROOM_LIMIT : ANONYMOUS_ROOM_LIMIT;
    const hasOwnerBypass = appUser?.plan === 'flashroom-owner';

    useEffect(() => {
        const getRoomCount = async () => {
            if (auth.isLoading) return;

            try {
                if (auth.isAuthenticated) {
                    if (!auth.user?.access_token) return;

                    const res = await api.get('/rooms/account/owned', {
                        headers: { Authorization: `Bearer ${auth.user.access_token}` },
                    });
                    setRoomCount(res.data.rooms.length);
                    return;
                }

                const clientId = localStorage.getItem('flashroom_id');
                if (!clientId) return;

                const res = await api.get(`rooms/byclient/${clientId}`);
                setRoomCount(res.data.rooms.length);
            } catch (err) {
            }
        };

        getRoomCount();
    }, [auth.isAuthenticated, auth.isLoading, auth.user?.access_token]);

    const createRoomLink =
        hasOwnerBypass || (auth.isAuthenticated && appUserLoading) || roomCount < roomLimit
            ? '/createroom'
            : '/rooms';

    return (
        <section id="home-s1-alt" style={{ backgroundImage: `url('images/cbb4.png')` }}>
            <div className="hero-bg-orb hero-bg-orb-1" />
            <div className="hero-bg-orb hero-bg-orb-2" />
            <div className="hero-grid-lines" />



            <div className="hero-inner-alt">
                <div id="s1s1-alt">


                    <div className="hero-copy-alt">
                        <h2>Copy. Paste. Share.</h2>
                        <h2 id="ed-to-alt">Edit. Together.</h2>
                    </div>

                    <p id="h1p-alt">
                        Share files, code, and notes in a room everyone can edit live.
                    </p>

                    <div className="hero-cta-row-alt">
                        <Link className="link-d" to={createRoomLink}>
                            <button style={{ textAlign: 'center' }} className="hero-btn-alt hero-btn-primary-alt">
                                Create Room
                            </button>
                        </Link>

                        <Link className="link-d" to="/join">
                            <button style={{ textAlign: 'center' }} className="hero-btn-alt hero-btn-secondary-alt">
                                Join Room
                            </button>
                        </Link>
                    </div>

                    <div className="hero-meta-alt">
                        <span>Real-time editing</span>
                        <span>File sharing</span>
                        <span>No signup to join</span>
                    </div>
                </div>

                <div id="home-intro-images-alt">
                    <div className="monitor-glow-alt" />

                    <div className="monitor-stack-alt">
                        <div id="hp-g-a-alt">
                            <img
                                id="hp-g-a-o-alt"
                                src="images/new-desktop.png"
                                alt="FlashRoom workspace monitor"
                            />

                            <div id="hp-g-c-alt">
                                <div className="hpgc-c-alt">
                                    <div className='hpgc-track-alt'>
                                        <img src="images/files1-o.png" alt="Scrolling file preview 1" />
                                        <br />
                                        <br />
                                        <img src="images/files1-o.png" alt="" aria-hidden="true" />
                                    </div>

                                </div>

                                <div className="hpgc-c-alt">
                                    <div className='hpgc-track-alt'>
                                        <img src="images/files2-o.png" alt="Scrolling file preview 2" />
                                        <br />
                                        <br />
                                        <img src="images/files2-o.png" alt="" aria-hidden="true" />
                                    </div>

                                </div>

                                <div className="hpgc-c-alt">
                                    <div className='hpgc-track-alt'>
                                        <img src="images/files3-o.png" alt="Scrolling file preview 3" />
                                        <br />
                                        <br />
                                        <img src="images/files3-o.png" alt="" aria-hidden="true" />
                                    </div>

                                </div>

                                <div className="hpgc-c-alt">
                                    <div className='hpgc-track-alt'>
                                        <img src="images/files4-o.png" alt="Scrolling file preview 4" />
                                        <br />
                                        <br />
                                        <img src="images/files4-o.png" alt="" aria-hidden="true" />
                                    </div>

                                </div>

                                <div className="hpgc-c-alt">
                                    <div className='hpgc-track-alt'>
                                        <img src="images/files5-o.png" alt="Scrolling file preview 5" />
                                        <br />
                                        <br />
                                        <img src="images/files5-o.png" alt="" aria-hidden="true" />
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroHeader;
